export { default as Slider, type SliderProps } from './Slider';
